<template>
  <div class="content-wrapper">
    <article class="description">
      <p class="desc-item">
        请在您的公众号中将此链接设置为关键词【听课】的自动回复内容。裂变出的用户将通过此链接到您的公众号领取课程。请在您的公众号中
      </p>
      <p class="desc-item">
        将此链接设置为关键词【听课】的自动回复内容。裂变出的用户将通过此链接到您的公众号领取课程。请在您的公众号中将此链接设置为关键词【听课】的自动回复内容。裂变出的用户将通过此链接到您的公众号领取课程。请在您的公众号中将此链接设置为关键词【听课】的自动回复内容。裂变出的用户将通过此链接到您的公众号领取课程。
      </p>
    </article>

    <section class="qr">
      <img :src="qrUrl" />
      <div class="tip">长按二维码添加客服号，申请入驻</div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'content',
  data () {
    return {
      qrUrl: process.env.VUE_APP_FOLLOW_QR,
    }
  },
  mounted () {
  },
}
</script>

<style lang="scss">
.content-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;

  .description {
    height: 0;
    flex-grow: 1;
    flex-shrink: 1;
    padding: 30px 20px 0;

    .desc-item {
      font-size: 14px;
      color: #e51c23;
      margin: 10px 0;
      text-indent: 2em;
    }
  }

  .qr {
    text-align: center;

    img {
      width: 50vw;
    }

    .tip {
      font-size: 14px;
      color: #101010;
      padding: 10px 0 60px;
    }
  }
}
</style>
